<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <!-- Botón de regreso -->
        <v-row dense class="align-center justify-space-between">
          <v-col cols="auto">
            <v-btn icon class="mb-2" @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <!-- Botón Cancelar <v-icon left>mdi-close</v-icon> -->
            <!--   <v-btn class="cancel" @click="Cancelar">
            Cancelar
          </v-btn> -->
            <!-- Botón Eliminar desde form-meta -->
            <!--    <form-meta
            :data="registro"
            :remove-commit="'removerAgroindustria'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          /> -->
            <!-- Botón Guardar -->
            <save-btn
              class="btn-oval"
              :record-status="registro.estatus"
              :loading="loading"
              @click="antesDeGuardar"
            />
          </v-col>
        </v-row>

        <v-col cols="12">
          <div class="text-h4 font-weight-bold">
            🍶 Producción y Venta Agroindustria
          </div>
        </v-col>
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Los campos con * son requeridos
          </div>
        </v-col>
        <!-- <v-col cols="12">
          <v-select
            v-model="registro.estatus"
            :items="estatus"
            label="Estatus"
            outlined
          />
        </v-col> -->
        <v-col cols="12">
          <v-select
            v-model="registro.id_finca"
            :no-data-text="$vuetify.noDataText"
            :rules="[r.required]"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Finca *"
            outlined
           
          >
           <!-- @input="debounceBuscarRegistroExistente" -->
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <!--        <v-col cols="6">
          <modal-establecimiento />
          <v-select
            v-model="registro.id_establecimiento"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :items="establecimientosPorId(registro.id_finca)"
            item-value="id"
            item-text="rua"
            label="Nombre del Local de Producción"
          ></v-select>
        </v-col> -->
        <v-col cols="12">
          <div class="d-flex justify-end">
            <modal-parcela />
          </div>
        </v-col>
        <v-col cols="12">
          <!-- Select de parcela ocupa casi todo el espacio -->
          <v-select
            class="flex-grow-1 mr-2"
            v-model="registro.id_parcela"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            dense
            :items="parcelasPorId(registro.id_finca)"
            item-value="id"
            item-text="nombre"
            label="Nombre de la planta o área de Producción"
          />
        </v-col>

        <!--
        <v-col cols="6">
          <n-date
            label="Fecha*"
            range-type="production"
            :rules="[r.required]"
            :date.sync="registro.fecha"
            @change="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            Número de turno o producción del día
          </div>
        </v-col>

        <v-col cols="12" md="5">
          <v-text-field
            v-model="registro.fecha"
            label="Fecha Inicio de Producción *"
            :rules="[r.required]"
            :date.sync="registro.fecha"
            placeholder="aaaa-mm-dd"
            outlined
            @input="validarFecha(registro.fecha)"
          ></v-text-field>
          <p v-if="error" style="color: red">{{ error }}</p>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model.number="registro.ciclo"
            :rules="[r.required, r.int, r.min_num(1), r.max_num(9)]"
            label="Turno: 1 para la primera producción del día, 2 para la segunda *"
            outlined
          />
        </v-col>
        <!--         <v-col cols="6">
          <v-text-field
            v-model="registro.fecha_fin"
            label="Fecha fin de ciclo*"
            range-type="production"
            :rules="[r.required]"
            :date.sync="registro.fecha_fin"
            placeholder="aaaa-mm-dd"
            outlined
            @change="validarFechaf"
          >
          </v-text-field>
          <p v-if="errorinf" style="color: red">{{ errorinf }}</p>
        </v-col> -->

        <v-col cols="12">
          <div class="text-h6 font-weight-bold">Datos del Producto</div>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="registro.descripcion"
            counter="1000"
            :rules="[r.required, r.max(1000)]"
            label="Qué produce ? Describa el producto, sus características y la Producción*"
            outlined
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold mb-2">Producción</div>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model.number="registro.produccion"
            :rules="[r.required, r.float]"
            label="Cantidad producida (en Kg, L, etc.)*"
            outlined
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model.number="registro.ingreso_anual"
            :rules="[r.required, r.float]"
            label="Merma (cantidad perdida) *"
            outlined
          />
        </v-col>

        <!-- Resultados de calidad -->
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            Observaciones y Control de Calidad
          </div>
        </v-col>

        <v-col cols="12">
          <v-textarea
            v-model="registro.observacion"
            :rules="[r.max(1000)]"
            label="Tarea_Pendiente, Fecha, Observación"
            auto-grow
            outlined
          />
        </v-col>
        <!-- Situación de desastre -->
        <!--         <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarDesastre">
            <v-icon left>mdi-plus</v-icon>
            Agregar situación de desastre
          </v-btn>
        </v-col>
        <situacion-de-desastre
          v-for="(desastre, index) in registro.desastres"
          :key="desastre.id_trxdano"
          :form="registro.desastres[index]"
          :modulo="'AGROINDUSTRIA'"
          @eliminar="eliminarDesastre(index)"
        /> -->
        <v-row class="pa-2" align="center" justify="space-around">
          <v-col cols="5" class="d-flex justify-center">
            <v-btn
              block
              large
              :color="seccionActiva === 'venta' ? '#66BB6A' : 'primary'"
              class="white--text font-weight-bold"
              elevation="4"
              @click="activarSeccion('venta')"
            >
              <span style="font-size: 30px">🛒</span>
              Ventas
            </v-btn>
          </v-col>
        </v-row>

        <!-- listado dinámico de destinos -->
        <div v-if="mostrarVenta" style="margin-top: 5px">
          LLena cada Venta y conocerás si tu trabajo rinde y te da beneficios.
          <destino
            :destinos="registro.destinos"
            :producciones="[{ produccion: registro.produccion }]"
            :listado-destinos="destino"
            :unit-select="false"
          />
        </div>
      </v-row>
    </v-form>
    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import Form from '@/components/js/Form'
import { mapGetters } from 'vuex'
import { danotrx, formulario_agroindustria } from '../../modelos'
import { clona } from '../../utilidades'
import * as rules from '@/utils/validations'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import ModalParcela from '../../components/ModalParcela.vue'
import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'

export default {
  name: 'Agroindustria',
  components: {
    Destino: () => import('@/components/form/Destino.vue'),
    FincaSelectItem,
    ModalParcela,
    ModalEstablecimiento,
    SituacionDeDesastre,
  },
  extends: Form,
  data: () => {
    return {
      seccionActiva: '',
      mostrarVenta: false,
      menuFecha: false,
      r: rules,
      error: '',
      errorinf: '',
      validado: false,
      modal_registro_existe: false,
      modal_registro_existe_loading: false,
      registro_existente: {},
      tabla_principal_id: 'id',
      tabla_produccion_id_rubro: '',
      ruta_registros: 'agroindustrias',
      ruta_registro: 'agroindustria',
      nombre_registros_en_state: 'agroindustrias',
      nombre_registro_en_state: 'agroindustria',
      dispatch_get_registro: 'getAgroindustria',
      dispatch_guardar_registro: 'guardarAgroindustria',
      registro: clona(formulario_agroindustria),
      registro_produccion: clona({}),
    }
  },
  computed: {
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'productor_actual',
    ]),
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Agroindustria')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
      //this.registro.fecha = this.formatearFechaParaFormulario(this.registro.fecha)
    } else {
      this.registro = clona(formulario_agroindustria)
      //Establece la fecha de inicio al cargar la página en fecha hoy
      //this.registro.fecha = this.fechaHoyDDMMYYYY()
    }

    this.registro.id_productor = this.productor_actual

    if (!this.registro.ciclo) {
      this.registro.ciclo = 1
    }
  },
  methods: {
    activarSeccion(seccion) {
      this.seccionActiva = seccion
      if (seccion === 'venta') {
        this.pmostrarVenta()
      }
    },
    pmostrarVenta() {
      this.mostrarVenta = true
    },
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.registro.id_productor
        const ciclo = this.registro.ciclo
        const fecha = this.registro.fecha
        const id_finca = this.registro.id_finca
        const id_parcela = this.registro.id_parcela

        // required fields to be fulfilled
        if (ciclo && fecha && id_finca) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarAgroindustriasx',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    Cancelar() {
      this.$router.push('/ru/agroindustrias')
    },
    agregarDesastre() {
      this.registro.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.registro.desastres?.splice(index, 1)
    },
    validarFecha(fecha) {
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // aaaa-mm-dd
      if (!regexFecha.test(fecha)) {
        this.error =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
        return
      }

      const [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.error = 'El mes debe estar en el rango de 1 a 12.'
        return
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.error = 'El día no es válido para el mes especificado.'
        return
      }

      this.error = ''
      // LO PUSE YO EN COMENTARIO this.debounceBuscarRegistroExistente()
    },
    validarFechaf() {
      // Tu lógica de validación para la fecha de inicio
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      const fecha = this.registro.fecha_fin
      if (!regexFecha.test(fecha)) {
        this.errorinf =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
      } else {
        let [, anio, mes, dia] = fecha.match(regexFecha)
        if (parseInt(mes) < 1 || parseInt(mes) > 12) {
          this.errorinf = 'El mes debe estar en el rango de 1 a 12.'
          return
        }
        let diasEnMes = new Date(anio, mes, 0).getDate()
        if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
          this.errorinf = 'El día no es válido para el mes especificado.'
          return
        }
        this.errorinf = ''
      }
    },
    formatearFechaParaBD(fechaDDMMYYYY) {
      const regex = /^(\d{2})-(\d{2})-(\d{4})$/
      if (!regex.test(fechaDDMMYYYY)) return fechaDDMMYYYY
      const [, dia, mes, anio] = fechaDDMMYYYY.match(regex)
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    formatearFechaParaFormulario(fechaYYYYMMDD) {
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regex.test(fechaYYYYMMDD)) return fechaYYYYMMDD
      const [, anio, mes, dia] = fechaYYYYMMDD.match(regex)
      return `${dia}-${mes}-${anio}`
    },
    fechaHoyDDMMYYYY() {
      const hoy = new Date()
      const dia = String(hoy.getDate()).padStart(2, '0')
      const mes = String(hoy.getMonth() + 1).padStart(2, '0') // los meses van de 0 a 11
      const anio = hoy.getFullYear()
      return `${dia}-${mes}-${anio}`
    },
    //esta funcion es para que las fechas se envien en el formato aaaa-mm-dd a la BD
    //antes de guardarycontinuar para no modificar la funcion original que esta en Form.js
    antesDeGuardar() {
      this.registro.fecha = this.formatearFechaParaBD(this.registro.fecha)
      this.registro.fecha_fin = this.formatearFechaParaBD(
        this.registro.fecha_fin
      )
      this.registro.destinos = this.registro.destinos.filter(
        (destino) => destino.produccion
      )
      //aqui llama entonces a la funcion guardar con la fecha lista
      this.guardarYContinuar()
    },
  },
}
</script>

<style>
.btn-oval {
  border-radius: 999px;
  padding-left: 24px;
  padding-right: 24px;
  font-weight: bold;
  min-width: 150px;
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}
</style>
